import React, { createContext, useContext, useState, useEffect } from 'react';

const SubscriptionContext = createContext();

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within SubscriptionProvider');
  }
  return context;
};

export const SubscriptionProvider = ({ children }) => {
  const [subscriptionTier, setSubscriptionTier] = useState('free'); // 'free' or 'premium'
  const [features, setFeatures] = useState({
    unlimited_messages: false,
    full_forum_access: false,
    eight_week_course: false,
    video_testimonials: false,
    downloadable_resources: false
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubscriptionTier();
  }, []);

  const fetchSubscriptionTier = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/subscription/tier`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setSubscriptionTier(data.subscription_tier || 'free');
        setFeatures(data.features || {});
      }
    } catch (error) {
      console.error('Failed to fetch subscription tier:', error);
    } finally {
      setLoading(false);
    }
  };

  const isPremium = subscriptionTier === 'premium';
  const isFree = subscriptionTier === 'free';

  const hasFeature = (featureName) => {
    return features[featureName] === true;
  };

  const refreshTier = () => {
    setLoading(true);
    fetchSubscriptionTier();
  };

  return (
    <SubscriptionContext.Provider
      value={{
        subscriptionTier,
        features,
        loading,
        isPremium,
        isFree,
        hasFeature,
        refreshTier
      }}
    >
      {children}
    </SubscriptionContext.Provider>
  );
};
